import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const selectGroups = (state: IAppState) => state.userGroups.userGroupList;

export const selectUserGroupsList = createSelector(
    selectGroups,
    (state: IUserGroupsList) => state.userGroupList
);

export const selectIsLoadingUserGroup = createSelector(
    selectGroups,
    (state: IUserGroupsList) => state.isLoading
);
